export { default } from './SpaceBase.js';
